import { render, staticRenderFns } from "./ListadoClientesTerrestresTabla.vue?vue&type=template&id=226eadb8"
import script from "./ListadoClientesTerrestresTabla.vue?vue&type=script&lang=js"
export * from "./ListadoClientesTerrestresTabla.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports